import React from 'react';
import styled from 'styled-components';

export const LoadingSpinner: React.FC<any> = ({ marginBottom, marginTop, justifyContent }) => {
    const LoadingSpinner = styled.div`
        border: 6px solid #f3f3f3;
        border-radius: 50%;
        border-top: 5px solid rgb(83, 87, 91);
        width: 40px;
        height: 40px;
        -webkit-animation: spin 2s linear infinite;
        -webkit-animation: spin 2s linear infinite;
        animation: spin 2s linear infinite;

        @-webkit-keyframes spin {
            0% {
                -webkit-transform: rotate(0deg);
            }
            100% {
                -webkit-transform: rotate(360deg);
            }
        }
        @keyframes spin {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }
    `;

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: justifyContent || 'space-around',
                marginTop: marginTop || '0px',
                marginBottom: marginBottom || '0px'
            }}
        >
            <LoadingSpinner />
        </div>
    );
};
